<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="name"
            clear-icon="mdi-close"
            label="Tên lớp bán trú"
            flat
            outlined
            dense
            clearable
            hide-details
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="status"
            :items="[
              { title: 'Đang học', status: 'active' },
              { title: 'Đã nghỉ', status: 'inactive' },
            ]"
            clear-icon="mdi-close"
            item-text="title"
            item-value="status"
            label="Chọn trạng thái"
            outlined
            dense
            clearable
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn dark outlined class="search-button mb-5" @click="onFilterChanged"> Tìm kiếm </v-btn>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data: () => ({ status: '', name: '' }),
  computed: {
    ...mapState('constant', ['dayboardingStatus']),
  },
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        name_contains: this.name,
        status: this.status,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
